document.addEventListener("DOMContentLoaded", () => {
    const homepage = document.getElementById("homepage");

    if (!homepage) {
        return;
    }

    const dialogNextSteps = document.getElementById("dialog-next-steps");

    if (!dialogNextSteps) {
        return;
    }

    const dialogNextStepsScrollToCenter = homepage.querySelector(
        ".dialog-next-steps-scroll-to-center",
    );
    const dialogNextStepsBody = dialogNextSteps.querySelector(".dialog-body");
    const activeStep = dialogNextStepsBody.querySelector(".active-step");

    if (
        !dialogNextSteps ||
        !dialogNextStepsScrollToCenter ||
        !dialogNextStepsBody ||
        !activeStep
    ) {
        return;
    }

    dialogNextStepsScrollToCenter.addEventListener("click", (e) => {
        // Scroll the div
        dialogNextSteps.scrollTo({
            top: activeStep.offsetTop / 1.5 - 157,
            behavior: "smooth",
        });
    });
});
